export const bottomTouch = (e, gap = 0) => {
    // gap: - number => use as-is OR - true => 0.9 (PMS legacy) OR- false => 0 (master behavior)
    const gapValue = typeof gap === 'boolean' ? (gap ? 0.9 : 0) : gap;
    return (Math.ceil(e.target.scrollTop) + Math.ceil(e.target.clientHeight) >= Math.ceil(e.target.scrollHeight) - (Math.ceil(e.target.clientHeight) * gapValue));
};

export const errorFocus = (flag) => {
    setTimeout(() => {
        const elem = document.getElementsByClassName('u_input-error')
        if (elem && elem[0]) {

            if (flag === 'top') elem[0].scrollIntoView({ behavior: "smooth" });
            else elem[0].scrollIntoView({ behavior: "smooth", block: "nearest", inline: 'nearest' });
        }
    }, 200)
}

export const isInViewport = (element, ref) => {
    return (
        element.getBoundingClientRect().top >= 0 &&
        element.getBoundingClientRect().bottom <= (ref.innerHeight || document.documentElement.clientHeight)
    );
}

const modalStack = [];
export const addModal = (id) => {
    modalStack.push(id);
};
export const removeModal = (id) => {
    const index = modalStack.lastIndexOf(id);
    if (index !== -1) modalStack.splice(index, 1);
};
export const getTopModal = () => {
    return modalStack[modalStack.length - 1];
};

export const handleBackEvent = () => {
    if (document.querySelectorAll(".ubs-overlay")[0])
        document.querySelectorAll(".ubs-overlay")[0].click();
    if (document.querySelectorAll(".ubs-popup-overlay")[0])
        document.querySelectorAll(".ubs-popup-overlay")[0].click();
    if (document.querySelectorAll(".ubs-white-overlay")[0])
        document.querySelectorAll(".ubs-white-overlay")[0].click();
    if (document.querySelectorAll(".ubs-close-popup")[0])
        document.querySelectorAll(".ubs-close-popup")[0].click();
};

export const getHighlightedText = (text, searchText) => {
    return text;
};

export const removeHighlightedMessage = () => {
    let els = document.querySelectorAll('.u_messages.u_highlight-message')
    for (let j = 0; j < els.length; j++) {
        els[j].classList.remove('u_highlight-message')
    }
}

export const insertAtCaret = (target, text) => {
    // target: element id string (framework) OR a React ref object (PMS)
    const textarea = typeof target === 'string' ? document.getElementById(target) : target?.current;
    if (!textarea || typeof textarea.value !== 'string') return;

    const scrollPos = textarea.scrollTop;
    const value = textarea.value;
    let caretPos = textarea.selectionStart ?? 0;

    const front = value.substring(0, caretPos);
    const back = value.substring(textarea.selectionEnd ?? 0, value.length);

    textarea.value = front + text + back;

    caretPos += text.length;
    textarea.selectionStart = caretPos;
    textarea.selectionEnd = caretPos;
    textarea.focus();
    textarea.scrollTop = scrollPos;
}

// ===== migrated from pms/src/common/functions/common.jsx =====
export const autoExpand = (field) => {
    // Reset field height
    field.style.height = 'inherit';
    // Get the computed styles for the element
    let computed = window.getComputedStyle(field);
    // Calculate the height
    let height = parseInt(computed.getPropertyValue('border-top-width'), 10)
        // + parseInt(computed.getPropertyValue('padding-top'), 10)
        + field.scrollHeight
        // + parseInt(computed.getPropertyValue('padding-bottom'), 10)
        + parseInt(computed.getPropertyValue('border-bottom-width'), 10);
    field.style.height = height + 'px';
};

export const autosize = (field) => {
    setTimeout(function () {
        field.style.cssText = 'height:auto; padding:0';
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        field.style.cssText = 'height:' + (field.scrollHeight + 40) + 'px';
    }, 0);
}

export const extractContent = (s) => {
    var span = document.createElement('span');
    span.innerHTML = s;
    return span.textContent || span.innerText;
};
